<template>
    <el-drawer :visible.sync="showModal" :wrapperClosable="false" :show-close="closable" :withHeader="false" size="60%">
        <slot name="header"></slot>
        <div class="content">
            <slot></slot>
        </div>
    </el-drawer>
</template>

<script>
    export default {
        name: "kllk-drawer",
        props: {
            value: {
                type: Boolean,
                default: false
            },
            // 右上角X按钮
            closable: {
                type: Boolean,
                default: false
            }

        },
        data() {
            return {
                showModal: this.value,
            }
        },
        watch: {
            value(n) {
                this.showModal = n;
            },
            showModal(n) {
                this.$emit("input", n)
            }
        },
        methods: {}
    }
</script>

<style lang='less' scoped>
    .content {
        height: 88vh;
        overflow-y: auto;
    }
</style>